var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* eslint-disable @typescript-eslint/naming-convention */
import DRM from '../drm';
import { END_STATE, PAUSE_TYPE, PLAY_MODE, SET_LEVEL_MODE, VIDEO_CONTAINER_CLASS, VIDEO_ELEMENT_STATE, VIDEO_EVTS, VIDEO_NODE_EVENT, VIDEO_READY_STATE, VIDEO_STATE, } from '../enums';
import { i18nConfig } from '../i18n';
import { AUDIO_TRACK_ERROR_MSG } from '../interfaces/iaudio-track';
import AutoPlayPolicy from '../libs/autoplay-policy';
import EvtEmitter from '../libs/event-emitter';
import SimpleDefer from '../libs/simple-defer';
import { commonTool, domTool, jsonTool, Logger, logMethodCallDecoratorCreator, LoopMode, t, TaskLoop, uaTool, videoTool, } from '../util';
import { CheckHealth, HEALTH_EVTS } from './check-health';
import CheckVideoNodeStatus from './check-videonode-status';
import { PlayerError } from './error';
import { kernelEvtBus } from './evt-bus';
import { LatencyController } from './latency-controller';
import Loading from './loading';
import { PerformanceMonitor } from './performance-monitor';
import { findFreeBaseVideoElement, IGNORE_VIDEO_EVT } from './play-helper';
import { StateMgr } from './state-mgr';
import VideoResizeAutoFill from './video-resize-autofill';
var logMethodCall = logMethodCallDecoratorCreator('BaseVideoNode');
var BaseVideoNode = /** @class */ (function (_super) {
    __extends(BaseVideoNode, _super);
    function BaseVideoNode(config) {
        var _a;
        var _this = _super.call(this) || this;
        _this._played = false;
        _this._evtBlocking = false;
        _this._pauseCloseToEndStateCheckTimeoutId = 0;
        /** seek操作的目标播放点 */
        _this._targetSeekTime = -1;
        /** 外部传入的startTime，起播后置0 */
        _this._userStartTime = 0;
        /** 是否是用户seek */
        _this._isUserSeek = false;
        _this.isUserSwitchAudioTrack = false;
        /** 首次缓冲超时的计时器id */
        _this.loadTimeoutId = 0;
        _this.levelSwitchTargetPlaytime = -1;
        /** 切换清晰度方式 */
        _this.setLevelMode = SET_LEVEL_MODE.SOFT;
        /** 是否存在外挂音轨 */
        _this.altAudio = false;
        /** 直播延迟控制器 */
        _this.latencyController = null;
        _this._logger = new Logger(config.instanceId, 'BaseVideoNode');
        _this._config = config;
        _this.stateMgr = new StateMgr(_this);
        _this.checkPlayHealth = new CheckHealth(_this);
        _this.loading = new Loading(_this);
        _this.setHealthEvents();
        _this.mainTaskLoop = new TaskLoop(_this.mainLoopInProcess.bind(_this), LoopMode.RAF);
        var container = _this._config.container;
        _this._video = _this.findFreeVideoElement();
        _this._autoPlayPolicy = new AutoPlayPolicy(_this._video, { instanceId: config.instanceId });
        _this._state = VIDEO_STATE.IDLE;
        _this._playbackRate = 1;
        _this._idx = 0;
        _this._videoInfo = null;
        _this._pauseType = void 0;
        // 绑定各种VideoNode播放事件
        _this._videoEventMap = (_a = {},
            _a[VIDEO_EVTS.loadstart] = _this.onVideoEventLoadStart.bind(_this),
            _a[VIDEO_EVTS.timeupdate] = _this.onVideoEventTimeUpdate.bind(_this),
            _a[VIDEO_EVTS.durationchange] = _this.onVideoEventDurationChange.bind(_this),
            _a[VIDEO_EVTS.volumechange] = _this.onVideoEventVolumeChange.bind(_this),
            _a[VIDEO_EVTS.canplay] = _this.onVideoEventCanplay.bind(_this),
            _a[VIDEO_EVTS.playing] = _this.onVideoEventPlaying.bind(_this),
            _a[VIDEO_EVTS.pause] = _this.onVideoEventPause.bind(_this),
            _a[VIDEO_EVTS.waiting] = _this.onVideoEventWaiting.bind(_this),
            _a[VIDEO_EVTS.seeking] = _this.onVideoEventSeeking.bind(_this),
            _a[VIDEO_EVTS.seeked] = _this.onVideoEventSeeked.bind(_this),
            _a[VIDEO_EVTS.loadeddata] = _this.onVideoEventLoadeddata.bind(_this),
            _a[VIDEO_EVTS.loadedmetadata] = _this.onVideoEventLoadedmetadata.bind(_this),
            _a[VIDEO_EVTS.ended] = _this.onVideoEventEnded.bind(_this),
            _a[VIDEO_EVTS.error] = _this.onVideoEventError.bind(_this),
            _a[VIDEO_EVTS.progress] = _this.onVideoEventProgress.bind(_this),
            _a[VIDEO_EVTS.ratechange] = _this.onVideoEventRateChange.bind(_this),
            _a[VIDEO_EVTS.resize] = _this.onVideoEventResize.bind(_this),
            _a);
        _this._drm = new DRM(_this._video, config.drmConfig, new Logger(config.instanceId, 'DRM'));
        _this._drm.on('error', _this.onDrmError.bind(_this));
        _this._eventMap = {
            video: _this.onVideoEvents.bind(_this),
        };
        _this._eventAddedMap = {};
        _this._videoElementContainer = domTool.getElementFromConfig(container).querySelector(".".concat(VIDEO_CONTAINER_CLASS));
        videoTool.appendElement(_this._video, _this._videoElementContainer);
        _this.performanceMonitor = new PerformanceMonitor(_this._video);
        _this.videoResizeAutoFill = new VideoResizeAutoFill(_this._video, _this._config.minFillBlackBorder);
        _this.vnStatusChecker = new CheckVideoNodeStatus(_this);
        if (config.type === PLAY_MODE.LIVE) {
            _this.latencyController = new LatencyController(_this._video, config.latencyConfig, _this.onLatencyExceeded.bind(_this), _this.onLatencyDropped.bind(_this), _this.latencyCalculationMethod.bind(_this));
        }
        return _this;
    }
    /** 第一次播放时（此时必须是用户触发），在js的同一个事件循环里直接调用一次video标签的play方法。*/
    BaseVideoNode.prototype.triggerAutoplay = function () {
        var _this = this;
        // 触发自动播放时候会调用video的play和pause方法，这时候的调用发出的事件需要丢弃
        this._evtBlocking = true;
        return this._autoPlayPolicy.userTrigger()
            .then(function () { return _this._evtBlocking = false; })
            .catch(function (e) {
            _this._evtBlocking = false;
            // 抛出错误让调用方catch
            throw e;
        });
    };
    BaseVideoNode.prototype.videoplay = function () {
        var _this = this;
        var _a;
        this._logger.log("videoplay(), uid=".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/state=").concat(this.state, "/idx=").concat(this.idx));
        var playPromise = this._video.play();
        if (playPromise) {
            playPromise.catch(function (e) {
                _this._logger.warn("".concat(_this.idx, " play() catch: ").concat(e.name, ", ").concat(e.message));
                var isAutoPlayBlocked = videoTool.isAutoPlayBlockedMessage(e.message);
                if (isAutoPlayBlocked) {
                    // 自动播放被阻止一定无法起播，可能用户在等待状态，此时要去掉loading动画
                    _this.loading.hide();
                }
                _this.emit(VIDEO_NODE_EVENT.PLAY_PROMISE_CATCHED, { videoInfo: _this._videoInfo, isAutoPlayBlocked: isAutoPlayBlocked });
            });
        }
        else {
            // 兼容 IE，play 返回 undefined 的情况下，直接返回一个 resolve 的 Promise
            playPromise = Promise.resolve();
        }
        this._video.playbackRate = this._playbackRate;
        return playPromise;
    };
    BaseVideoNode.prototype.pause = function (type) {
        if (type === void 0) { type = PAUSE_TYPE.USER; }
        if (!this._played) {
            this._logger.warn('pause(), VideoNode has not been played');
            return;
        }
        if (!this.stateMgr.validCallState(VIDEO_STATE.PAUSE)) {
            this._logger.log("call pause in invaild state ".concat(this._state));
            return;
        }
        this.pauseInner(type);
    };
    BaseVideoNode.prototype.resume = function () {
        throw new Error('not implements');
    };
    BaseVideoNode.prototype.stop = function () {
        this.stopInner();
    };
    BaseVideoNode.prototype.destroy = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.stopInner();
        (_a = this.latencyController) === null || _a === void 0 ? void 0 : _a.destroy();
        this.latencyController = null;
        if (this._video) {
            if (this._eventMap) {
                this.setVideoEvents(false);
                this._eventMap = null;
            }
            videoTool.clear(this._video);
            videoTool.removeElement(this._video, this._videoElementContainer);
            this._video.dataset.used = VIDEO_ELEMENT_STATE.FREE;
        }
        (_b = this._autoPlayPolicy) === null || _b === void 0 ? void 0 : _b.destroy();
        this._autoPlayPolicy = null;
        (_c = this.stateMgr) === null || _c === void 0 ? void 0 : _c.destroy();
        this.stateMgr = null;
        this.removeAllListeners();
        (_d = this._drm) === null || _d === void 0 ? void 0 : _d.destroy();
        this._drm = null;
        this._video = null;
        this._videoInfo = null;
        this._videoElementContainer = null;
        this._played = false;
        this._config = null;
        (_e = this.checkPlayHealth) === null || _e === void 0 ? void 0 : _e.destroy();
        this.checkPlayHealth = null;
        (_f = this.loading) === null || _f === void 0 ? void 0 : _f.clearDelay();
        this.loading = null;
        (_g = this.mainTaskLoop) === null || _g === void 0 ? void 0 : _g.destroy();
        this.mainTaskLoop = null;
        this.performanceMonitor = null;
        (_h = this.videoResizeAutoFill) === null || _h === void 0 ? void 0 : _h.destroy();
        this.videoResizeAutoFill = null;
        (_j = this.vnStatusChecker) === null || _j === void 0 ? void 0 : _j.destroy();
        this.vnStatusChecker = null;
        this._logger.log('VideoNode has been destroyed!');
    };
    BaseVideoNode.prototype.setLevel = function (mode) {
        if (mode === void 0) { mode = SET_LEVEL_MODE.HARD; }
        if (!this.checkCanSetLevel()) {
            return Promise.reject(new Error('setLevel can\'t start'));
        }
        this._logger.log('setLevel(), succ exec: ', this._videoInfo);
        var levelSwitchTargetPlaytime = this._videoInfo.playtime;
        this.load(this._videoInfo, { startTime: levelSwitchTargetPlaytime });
        this.play();
        var defer = new SimpleDefer();
        this._levelSwitchingDefer = defer;
        this.levelSwitchTargetPlaytime = levelSwitchTargetPlaytime;
        this.loading.show();
        this.emit(VIDEO_NODE_EVENT.SETLEVEL_START, { videoInfo: this._videoInfo, mode: mode });
        return defer.promise;
    };
    /** 是否正在切换清晰度 */
    BaseVideoNode.prototype.getLevelSwitching = function () {
        return !!this._levelSwitchingDefer;
    };
    BaseVideoNode.prototype.setAudioTrack = function (id) {
        if (!this.checkCanSetAudioTrack()) {
            return Promise.reject(AUDIO_TRACK_ERROR_MSG.STATE_INVALID);
        }
        // base不支持切换音轨
        return Promise.reject(AUDIO_TRACK_ERROR_MSG.NOT_SUPPORT);
    };
    /** 是否存在外挂音轨 */
    BaseVideoNode.prototype.hasAltAudio = function () {
        return this.altAudio;
    };
    /** 当前播放的资源是否是DRM加密的 */
    BaseVideoNode.prototype.isCurrentContentDRMEncrypted = function () {
        // 没有播放内容的话默认是不加密的
        if (this._state === VIDEO_STATE.IDLE) {
            return false;
        }
        return this._drm.hasStarted();
    };
    Object.defineProperty(BaseVideoNode.prototype, "volume", {
        get: function () {
            if (this._video.muted) {
                return 0;
            }
            return this._video.volume;
        },
        set: function (value) {
            if (value < 0 || value > 1) {
                this._logger.warn('The volume value range is [0,1]');
                return;
            }
            this._video.volume = value;
            this._video.muted = value <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "playtime", {
        /** 播放进度（不一定是video标签的currentTime，如果是不间断播放，video标签时间不断增长，但该属性只是单个播放段上的偏移播放时间）*/
        get: function () {
            return this._videoInfo ? this._videoInfo.playtime : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (value) {
            var _a;
            if (this._state === value) {
                return;
            }
            var oldState = this._state;
            this._state = value;
            if (this._videoInfo) {
                this._videoInfo.state = this._state;
            }
            this._logger.log("set state(), uid=".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/idx=").concat(this._idx, "/old=").concat(oldState, "/new=").concat(value));
            var evtData = {
                videoInfo: this._videoInfo,
                new: value,
                old: oldState,
            };
            // 以下状态需要增加特殊字段派发出去
            if (value === VIDEO_STATE.PAUSE) {
                evtData.pauseType = this._pauseType || PAUSE_TYPE.SYS; // 既不是程序触发也不是用户触发（那就是系统莫名其妙触发）
                this._pauseType = void 0;
            }
            else if (value === VIDEO_STATE.SEEKING) {
                evtData.seekingTime = this._targetSeekTime;
                evtData.isUserSeek = this._isUserSeek;
                this._targetSeekTime = -1;
            }
            else if (value === VIDEO_STATE.SEEKED) {
                evtData.isUserSeek = this._isUserSeek;
            }
            this.setLoadingOnStateChange();
            this.emit(VIDEO_NODE_EVENT.STATE_CHANGE, evtData);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "played", {
        /** 获取当时视频播放是否已经起播过 */
        get: function () {
            return this._played;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "useWorker", {
        /** 是否使用了worker来进行流的处理。各个内核需要复写，所以不能通过readonly方式写成属性，先eslint-disalbe吧 */
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "idx", {
        get: function () {
            return this._idx;
        },
        set: function (value) {
            this._idx = value;
            this._video.dataset.idx = "".concat(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "videoElement", {
        get: function () {
            return this._video;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "videoSize", {
        get: function () {
            return { width: this._video.videoWidth, height: this._video.videoHeight };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "videoBuffered", {
        get: function () {
            return videoTool.getBuffered(this._video);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "config", {
        get: function () {
            return this._config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "playbackRate", {
        get: function () {
            return this._video.playbackRate;
        },
        set: function (value) {
            this._playbackRate = value;
            // 如果不支持倍速的浏览器，会出现: "NotSupportedError" DOMException
            try {
                this._video.playbackRate = value;
            }
            catch (e) {
                this._logger.warn("set playbackRate: ".concat(e === null || e === void 0 ? void 0 : e.message));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "currentVideoInfo", {
        get: function () {
            return this._videoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "supportPlaybackRate", {
        get: function () {
            // x5的mse不支持倍速
            return !uaTool.browser.x5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "duration", {
        get: function () {
            var vduration = this._videoInfo ? this._videoInfo.duration : 0;
            // 没有赋值src的时候HTMLVIDEOELEMENT.duration可能返回NaN
            return Number.isNaN(vduration) ? 0 : vduration;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 计算当前直播延迟
     *
     * @protected
     */
    BaseVideoNode.prototype.latencyCalculationMethod = function (currentTime, buffered) {
        // base未实现，子类实现
        return -1;
    };
    ;
    /**
     * 当前直播延迟超出期望延迟时的回调
     *
     * @protected
     */
    BaseVideoNode.prototype.onLatencyExceeded = function (currentTime, latency, media) {
        // base未实现，子类实现
    };
    ;
    /**
     * 当前直播延迟回落到期望延迟时的回调
     *
     * @protected
     */
    BaseVideoNode.prototype.onLatencyDropped = function (currentTime, latency, media) {
        // base未实现，子类实现
    };
    ;
    BaseVideoNode.prototype.setHealthEvents = function () {
        var _this = this;
        var healthEvtHandler = function (e) {
            _this._logger.warn("get health evt!!! evt=".concat(e.type, "/uid=").concat(_this._videoInfo.uid, "/idx=").concat(_this._idx, "/state=").concat(_this._state));
            _this.errorHandler(e.data);
        };
        this.checkPlayHealth.on(HEALTH_EVTS.STATE_STUCK, healthEvtHandler);
        this.checkPlayHealth.on(HEALTH_EVTS.PLAYTIME_STUCK, healthEvtHandler);
    };
    /** 设置video标签的事件监听 */
    BaseVideoNode.prototype.setVideoEvents = function (value) {
        var _this = this;
        var _a;
        if (this._eventAddedMap.videoEventAdded === value) {
            return;
        }
        this._logger.log("setVideoEvents(), idx=".concat(this._idx, "/value=").concat(value, "/uid=").concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid));
        this._eventAddedMap.videoEventAdded = value;
        Object.keys(this._videoEventMap).forEach(function (key) {
            if (value) {
                _this._video.addEventListener(key, _this._eventMap.video);
            }
            else {
                _this._video.removeEventListener(key, _this._eventMap.video);
            }
        });
    };
    /**
     * 对video标签的事件做处理
     * @param e 播放事件参数
     */
    BaseVideoNode.prototype.onVideoEvents = function (e) {
        var _this = this;
        var _a;
        // 这些条件下，事件都丢弃（evtBlocking会在自动播放触发前设置，自动播放触发结束后恢复）
        if (this.state === VIDEO_STATE.IDLE || !this._videoInfo || this._evtBlocking) {
            this._logger.log("videoevt discard, idx=".concat(this._idx, "/uid=").concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/evttype=").concat(e.type, "/")
                + "state=".concat(this.state, "/evtBlocking=").concat(this._evtBlocking));
            return;
        }
        if (!IGNORE_VIDEO_EVT.includes(e.type)) {
            this._logger.log("videoevt, uid=".concat(this._videoInfo.uid, "/idx=").concat(this.idx, "/type=").concat(e.type, "/")
                + "time=".concat(this._video.currentTime, "/duration=").concat(this._video.duration));
        }
        // 由于状态机会过滤掉很多事件，因此额外将video标签的所有事件抛出
        this.emit(VIDEO_NODE_EVENT.ELEMENT_EVTS, { videoInfo: this._videoInfo, elementEvtType: e.type });
        var closeToEnd = Math.abs(this._videoInfo.duration - this._videoInfo.playtime) < 0.1
            && this._videoInfo.duration > 0;
        if (e.type === 'pause' && closeToEnd) {
            // 某些浏览器会在结束之前抛出pause事件，如果原封不动的抛出事件可能会导致引用方误判。因此做一个延迟，如果马上收到ended事件，则不会派发。
            this._pauseCloseToEndStateCheckTimeoutId = window.setTimeout(function () {
                if (_this._videoEventMap[e.type]) {
                    _this._videoEventMap[e.type](e);
                }
            }, 0);
            return;
        }
        if (e.type === 'ended' && this._pauseCloseToEndStateCheckTimeoutId > 0) {
            window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId);
            this._pauseCloseToEndStateCheckTimeoutId = 0;
        }
        if (this._videoEventMap[e.type]) {
            this._videoEventMap[e.type](e);
        }
    };
    BaseVideoNode.prototype.onVideoEventPlaying = function () {
        this.setCheckLoadTimeoutEnable(false);
        // 起播后要重置seeking标记
        this._isUserSeek = false;
        // 移动端chrome播放直播貌似收到loadedmetadata事件时候还可能为0，因此在这里再赋值一次给videoinfo
        this.updateVideoSize();
        if (uaTool.browser.x5) {
            // 如果是先调用video.load()，x5浏览器在playing之前获取到的duration一直是0，包括在durationchange事件里面
            // 所以这里在playing的时候再获取一遍了，出bug的ua：
            // Mozilla/5.0 (Linux; Android 9; Redmi Note 7 Pro Build/PKQ1.181203.001; wv) AppleWebKit/537.36
            // (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045224
            this.onVideoEventDurationChange();
        }
        if (!this._videoInfo.hasFirstPlaying) {
            this.emit(VIDEO_NODE_EVENT.FIRST_PLAYING, { videoInfo: this._videoInfo });
        }
        this.stateMgr.receiveVideoEvt(VIDEO_EVTS.playing);
        // 在事件中videoInfo可能已被销毁，所以判断一下是否存在
        if (this._videoInfo) {
            // 在firstPlaying事件发出后、状态修改以后，再修改此变量。因为外部判断首次播放可能使用的!videoNode.hasFirstPlaying
            this._videoInfo.hasFirstPlaying = true;
            this._videoInfo.stateWhenErrorHappen = null;
        }
        this._userStartTime = 0;
        this.checkSetLevelOver(VIDEO_EVTS.playing);
    };
    BaseVideoNode.prototype.onVideoEventCanplay = function () {
        this.setCheckLoadTimeoutEnable(false);
        if (!this._videoInfo) {
            return;
        }
        if (!this._videoInfo.qualityInfo.canplaytime) {
            this._videoInfo.qualityInfo.canplaytime = videoTool.getBuffered(this._video);
        }
        this.stateMgr.receiveVideoEvt(VIDEO_EVTS.canplay);
    };
    BaseVideoNode.prototype.onVideoEventPause = function () {
        if (this._pauseType !== PAUSE_TYPE.INNER) {
            // 过滤掉播放器内部调用的pause，例如切清晰度前程序调用的pause
            this.stateMgr.receiveVideoEvt(VIDEO_EVTS.pause);
        }
    };
    BaseVideoNode.prototype.onVideoEventEnded = function () {
        this._logger.log('setEndInner(), reason=endedEvt');
        this.setEndInner();
    };
    BaseVideoNode.prototype.onVideoEventSeeked = function () {
        this.stateMgr.receiveVideoEvt(VIDEO_EVTS.seeked);
        this.checkSetLevelOver(VIDEO_EVTS.seeked);
        this.resumeAfterSeek();
        // 重置userSeek标签
        this._isUserSeek = false;
    };
    /** 提供给有需要的继承类复写 */
    BaseVideoNode.prototype.onVideoEventLoadStart = function () {
    };
    BaseVideoNode.prototype.onVideoEventWaiting = function () {
        this.stateMgr.receiveVideoEvt(VIDEO_EVTS.waiting);
    };
    BaseVideoNode.prototype.onVideoEventSeeking = function () {
        this.stateMgr.receiveVideoEvt(VIDEO_EVTS.seeking);
    };
    BaseVideoNode.prototype.onVideoEventProgress = function () {
        this.emit(VIDEO_NODE_EVENT.VIDEO_BUFFER_CHANGE, { videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventLoadedmetadata = function (e) {
        this.updateVideoSize();
        this.emit(VIDEO_NODE_EVENT.METADATA_CHANGE, { videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventResize = function () {
        this.updateVideoSize(true);
    };
    BaseVideoNode.prototype.onVideoEventRateChange = function () {
        this.emit(VIDEO_NODE_EVENT.RATE_CHANGE, { playbackRate: this.playbackRate, videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventDurationChange = function () {
        if (this._video.duration > 0 && this._video.duration !== this._videoInfo.duration) {
            this._videoInfo.duration = this._video.duration;
            this._logger.log("onVideoEventDurationChange(), uid=".concat(this._videoInfo.uid, "/duration=").concat(this._videoInfo.duration, "/")
                + "idx=".concat(this.idx));
            this.emit(VIDEO_NODE_EVENT.DURATION_CHANGE, { videoInfo: this._videoInfo });
        }
    };
    BaseVideoNode.prototype.onVideoEventVolumeChange = function () {
        this.emit(VIDEO_NODE_EVENT.VOLUME_CHANGE, { volume: this.volume, videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventTimeUpdate = function () {
        var _a;
        if (this._video.currentTime === 0) {
            return;
        }
        this.updatePlaytime(this._video.currentTime);
        this.checkSetLevelOver(VIDEO_EVTS.timeupdate);
        // 部分浏览器中直播状态下出现buffer后只抛出canplay事件，不抛出playing事件
        // 导致状态扭转出现异常，所以我们在timeupdate中检查，如果处于buffering状态
        // 且readystate >=3，强制扭转为playing，避免被识别为卡死
        if (this._state === VIDEO_STATE.BUFFERING && this._video.readyState >= VIDEO_READY_STATE.HAVE_FUTURE_DATA) {
            this.stateMgr.setPlaying();
        }
        var intervalFrameDropped = (_a = this.performanceMonitor) === null || _a === void 0 ? void 0 : _a.calcIntervalFrameDropped();
        if (typeof intervalFrameDropped === 'number' && this._videoInfo) {
            this._videoInfo.qualityInfo.intervalFrameDropped = intervalFrameDropped;
        }
    };
    BaseVideoNode.prototype.onAudioTrackSwitched = function (id, fail) {
        if (fail === void 0) { fail = false; }
        if (this.audioTrackSwitchingDefer) {
            this.audioTrackSwitchingDefer.resolve({ userTrigger: this.isUserSwitchAudioTrack, id: id, fail: fail });
            this.audioTrackSwitchingDefer = null;
            this.emit(VIDEO_NODE_EVENT.SET_AUDIO_TRACK_OVER, {
                videoInfo: this._videoInfo,
                id: id,
                fail: fail,
                userTrigger: this.isUserSwitchAudioTrack,
            });
        }
    };
    BaseVideoNode.prototype.onVideoEventLoadeddata = function () {
        this.emit(VIDEO_NODE_EVENT.VIDEO_BUFFER_CHANGE, { videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventError = function () {
        this.errorHandler();
    };
    BaseVideoNode.prototype.onDrmError = function (event) {
        var _a = event.data, code = _a.code, message = _a.message, detail = _a.detail;
        var error = PlayerError.EncryptionError({
            code: code,
            detail: detail,
            message: message,
        });
        this._videoInfo.error = error;
        this.stopInner(false, this._videoInfo);
    };
    /** 检查是否能切换清晰度 */
    BaseVideoNode.prototype.checkCanSetLevel = function () {
        var setLevelDetail = this.vnStatusChecker.checkCanSetLevel();
        if (setLevelDetail.canSetLevel) {
            return true;
        }
        this._logger.warn(setLevelDetail.message);
        return false;
    };
    /**
     * 检查切换清晰度是否结束
     * @param evtName 事件名，切换清晰度完成可能在多个事件中检查。
     */
    BaseVideoNode.prototype.checkSetLevelOver = function (evtName) {
        var setLevelDetail = this.vnStatusChecker.checkIsSetLevelOver(evtName, this.levelSwitchTargetPlaytime);
        if (setLevelDetail) {
            this._logger.log('setLevelOver(), reason: '
                + "succOnPlaying=".concat(setLevelDetail.succInPlaying, "/succOnSeeked=").concat(setLevelDetail.succInSeeked, "/succOnTimeupdate=").concat(setLevelDetail.succInTimeupdate));
            this.setLevelOver();
        }
    };
    /** 切换清晰度结束 */
    BaseVideoNode.prototype.setLevelOver = function () {
        if (!this._levelSwitchingDefer) {
            return;
        }
        this._levelSwitchingDefer.resolve();
        this._levelSwitchingDefer = null;
        this.levelSwitchTargetPlaytime = -1;
        this.loading.hide();
        this.stateMgr.onSetLevelOver();
        this.emit(VIDEO_NODE_EVENT.SETLEVEL_OVER, { videoInfo: this._videoInfo });
    };
    /**
   * 检查是否可以切换清晰度。
   * @param time 切换时间
   * @returns 是否可执行切换动作
   */
    BaseVideoNode.prototype.checkCanSeek = function (time, userActivation) {
        if (userActivation === void 0) { userActivation = false; }
        var seekDetail = this.vnStatusChecker.checkCanSeek({
            seektime: time,
            userActivation: userActivation,
            setLevelMode: this.setLevelMode,
        });
        if (seekDetail.canSeek) {
            return true;
        }
        this._logger.warn(seekDetail.message);
        return false;
    };
    /** 检查是否可以切换音轨 */
    BaseVideoNode.prototype.checkCanSetAudioTrack = function () {
        var setAudioTrackDetail = this.vnStatusChecker.checkCanSetAudioTrack(this.audioTrackSwitchingDefer);
        if (setAudioTrackDetail.canSetAudioTrack) {
            return true;
        }
        this._logger.warn(setAudioTrackDetail.message);
        return false;
    };
    /** 从config传入的video标签数组查找未使用的video标签（是否在文档流中），提供标准查找方法但部分内核需要复写 */
    BaseVideoNode.prototype.findFreeVideoElement = function () {
        return findFreeBaseVideoElement(this._config.videoElements);
    };
    /** 设置播放主循环是否启用。用于每帧检查播放进度、监控缓冲状态下是否卡死等 */
    BaseVideoNode.prototype.setMainLoopEnable = function (value) {
        if (value) {
            this.mainTaskLoop.start();
        }
        else {
            this.mainTaskLoop.stop();
        }
    };
    /** 主循环执行函数 */
    BaseVideoNode.prototype.mainLoopInProcess = function () {
        this.updateAccuratePlaytime();
        this.checkPlayHealth.loop();
    };
    /** 更新更精确的时间，普通video事件的间隔时间精确到0.2~0.3s，此函数中精确到0.0167s */
    BaseVideoNode.prototype.updateAccuratePlaytime = function () {
        var _a;
        // 这里有3个条件，不满足任意case，跳过检查
        // 1. 播放器要处于playing状态，我们认为是在“播放中”
        // 2. video的duration要为正（兼容wasm内核没有ready state的情况）
        // 3. video的ready state小于4（兼容不存在ready state的case，不能使用 !== 4)
        if (this._state !== VIDEO_STATE.PLAYING
            || this._video.duration <= 0
            || this._video.readyState < VIDEO_READY_STATE.HAVE_ENOUGH_DATA) {
            return;
        }
        // 如果外部有传入回调函数用于播放时间粒度更小的事务执行，在此调用外部回调
        (_a = this.onAccurateTimeupdate) === null || _a === void 0 ? void 0 : _a.call(this, this._video.currentTime, this._video.duration);
        // 更新更精确的时间
        this.updatePlaytime(this._video.currentTime, true);
    };
    BaseVideoNode.prototype.updatePlaytime = function (value, silentEvt) {
        if (silentEvt === void 0) { silentEvt = false; }
        if (!this._videoInfo) {
            return;
        }
        var _a = this.performanceMonitor.report(), averageDecodeTimeInMs = _a.averageDecodeTimeInMs, totalVideoFrames = _a.totalVideoFrames, droppedVideoFrames = _a.droppedVideoFrames, frameDroppedInPercentage = _a.frameDroppedInPercentage;
        this._videoInfo.qualityInfo.droppedVideoFrames = droppedVideoFrames;
        this._videoInfo.qualityInfo.totalVideoFrames = totalVideoFrames;
        this._videoInfo.qualityInfo.averageDecodeTimeInMs = averageDecodeTimeInMs;
        this._videoInfo.qualityInfo.frameDroppedInPercentage = frameDroppedInPercentage;
        if (this._videoInfo.playtime !== value) {
            this._videoInfo.playtime = value;
        }
        if (!silentEvt) {
            this.emit(VIDEO_NODE_EVENT.TIME_UPDATE, { videoInfo: this._videoInfo });
        }
    };
    BaseVideoNode.prototype.setCheckLoadTimeoutEnable = function (isSetTimer) {
        var _this = this;
        this.loadTimeoutId && clearTimeout(this.loadTimeoutId);
        if (!isSetTimer)
            return;
        var maxPreloadTimeout = this._config.maxPreloadTimeout;
        if (maxPreloadTimeout <= 0)
            return;
        this.loadTimeoutId = setTimeout(function () {
            if (document.visibilityState === 'hidden') {
                return;
            }
            _this.errorHandler(PlayerError.NativeError({
                code: 104 /* ORG_LOAD_TIMEOUT */,
                detail: commonTool.isPageHidden(),
                fatal: false,
                message: t(i18nConfig.core.ERROR_PRELOAD_VIDEO_TIMEOUT),
            }));
        }, maxPreloadTimeout);
    };
    /** 拖动以后恢复播放或恢复播放状态 */
    BaseVideoNode.prototype.resumeAfterSeek = function () {
        if (!this._played || this._video.ended || !this._isUserSeek) {
            // 未开播前（比如只是预加载视频）or 视频已经播放结束 or 不是用户的seek操作，不需要在seek以后恢复播放
            return;
        }
        // 状态机定义中统一规定无论何种状态下seek，seek成功以后变为playing状态
        if (!this._video.paused) {
            // 如果不是暂停状态（播放状态下拖动），强行恢复到playing状态
            // （一般浏览器都会在seeked事件以后紧跟canplay、playing事件出来，少数浏览器保持seeked状态。但强行设置playing状态也没关系，如果后续
            // 又来canplay、playing状态都不会覆盖已经强行设置的playing状态，因为不符合状态表而被过滤）
            this.stateMgr.setPlaying();
            return;
        }
        // 如果是暂停状态下seek，结束以后也恢复播放
        if (!this._config.remainPauseStateAfterSeek) {
            // 但这里除开一种情况，外部指定要保留暂停状态！
            this.videoplay();
        }
    };
    BaseVideoNode.prototype.pauseInner = function (type) {
        var _a;
        if (type === void 0) { type = PAUSE_TYPE.INNER; }
        this._logger.log("pause(), uid=".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/state=").concat(this.state, "/idx=").concat(this.idx, "/type=").concat(type));
        this._pauseType = type;
        this._video.pause();
    };
    BaseVideoNode.prototype.setEndInner = function () {
        if (this._state !== VIDEO_STATE.END && this._state !== VIDEO_STATE.IDLE) {
            this._logger.log("setEndInner(), idx=".concat(this._idx, "/uid=").concat(this._videoInfo.uid, "/playtime=").concat(this._videoInfo.playtime)
                + "/duration=".concat(this._videoInfo.duration, "}"));
            // 这里不能直接停止（调用videoNode的stop），因为在列表播放时，即使当前视频停止，也可能会append地址进来继续播放，需要复用一些变量。
            // （参考代码位置①来理解）
            this.stateMgr.setEnded(); // 本段播放结束
            this.emit(VIDEO_NODE_EVENT.PLAY_OVER, {
                isUserStop: false,
                endState: END_STATE.NORMAL,
                videoInfo: this._videoInfo,
            });
        }
    };
    BaseVideoNode.prototype.stopInner = function (keepState, videoInfo) {
        var _a, _b;
        if (!this._video || !this._videoInfo) {
            return;
        }
        (_a = this.performanceMonitor) === null || _a === void 0 ? void 0 : _a.reset();
        this.setMainLoopEnable(false);
        this.setCheckLoadTimeoutEnable(false);
        // 停掉之后直接重置seek标记
        this._isUserSeek = false;
        this._logger.log("stopInner(), uid/state/idx: ".concat((_b = this._videoInfo) === null || _b === void 0 ? void 0 : _b.uid, "/").concat(this.state, "/").concat(this.idx));
        this.setVideoEvents(false);
        if (this._config.clearVideoAfterStop) {
            // 调用videoTool.clear接口清除video标签画面
            videoTool.clear(this._video);
        }
        else {
            // 如果保留画面，播放结束仅暂停，等下一次load时才会清理
            this._video.pause();
        }
        if (this._config.createVideoNodeWhenLoad) {
            // 如果确定是load时会重新创建新的VideoNode，那么此VideoNode在停止时需要释放video标签。
            this._video.dataset.used = VIDEO_ELEMENT_STATE.FREE;
        }
        if (this._videoInfo) {
            this._videoInfo.extraVars.isLoadstarted = false;
            this._videoInfo = null;
        }
        if (this._pauseCloseToEndStateCheckTimeoutId > 0) {
            window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId);
            this._pauseCloseToEndStateCheckTimeoutId = 0;
        }
        if (this.state === VIDEO_STATE.IDLE) {
            // 当前视频段已经播放结束，状态机被重置为idle。但是并没有清除videoInfo等变量。如果重播，会默认调用stop方法，导致
            // 重复的end、idle状态变化，类似end -> idle -> （重播）-> end -> idle。return语句排除这种情况。
            // （参考代码位置①）
            return;
        }
        if (!keepState) {
            this.stateMgr.setEnded();
            this._played = false;
            // 不保持状态的时候，才会清理正在切清晰度的变量。
            // （例如切换清晰度时出错，会重试备份地址，调用stopInner传入keepState为true，此时还在切清晰度，不能清理此变量）
            this._levelSwitchingDefer = null;
            if (videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.error) {
                this.emit(VIDEO_NODE_EVENT.ERROR, { videoInfo: videoInfo });
            }
        }
    };
    /** 更新视频尺寸 */
    BaseVideoNode.prototype.updateVideoSize = function (isNativeEvt) {
        if (isNativeEvt === void 0) { isNativeEvt = false; }
        var vw = this._video.videoWidth;
        var vh = this._video.videoHeight;
        if (this._videoInfo && (this._videoInfo.videoWidth !== vw || this._videoInfo.videoHeight !== vh)) {
            this._videoInfo.videoWidth = vw;
            this._videoInfo.videoHeight = vh;
            this.emit(VIDEO_NODE_EVENT.VIDEO_RESIZE, { videoInfo: this._videoInfo, isNative: isNativeEvt });
            this.videoResizeAutoFill.resizeAutoFill();
        }
    };
    /** 当播放状态变化时设置loading动画是否展示 */
    BaseVideoNode.prototype.setLoadingOnStateChange = function () {
        // 未开播之前的状态变化，都不显示loading
        if (!this._played) {
            this.loading.hide();
            return;
        }
        // 播放中缓冲和开始Seek状态需要显示loading动画
        if ([VIDEO_STATE.BUFFERING, VIDEO_STATE.SEEKING].includes(this._state)) {
            var delayTimeMS = 500;
            // 变为seeking、buffering等状态，显示loading动画，但是延迟一定时间展示，避免出现loading动画很快出现又消失
            this.loading.show(delayTimeMS);
            return;
        }
        // 下面逻辑判断何时去掉loading动画
        if (
        // 直播只有canplay状态才去掉loading动画，[注意]直播时canplay不去掉loading动画的原因是：
        // 当某些浏览器（wechat-ios）不支持自动播放时调用load接口无法加载数据，BaseVideoNode会强行派发一个canplay状态出去，然后等用户点击
        // 用户点击播放以后调用play，此时才真正开始加载数据并播放。此种场景如果canplay状态去掉了loading动画，play以后就会有较长时间的黑屏而
        // 没有loading，体验较差。因此，直播在canplay的时候不去掉loading动画，而是在autoplayBlock/playing两种情况下去掉。这样可以保证体验
        (this._config.type === PLAY_MODE.LIVE && VIDEO_STATE.CANPLAY !== this._state)
            // 点播除了上面的buffering和seeking状态，都不显示
            || this._config.type === PLAY_MODE.VOD) {
            this.loading.hide();
        }
    };
    /**
     * 出错时的处理函数
     * @param errorData 原始错误数据
     */
    BaseVideoNode.prototype.errorHandler = function (errorData) {
        var error = this.parseErrorData(errorData);
        this._logger.log('video encounter error', error);
        var isCurrentPositionBuffered = videoTool.isPositionBuffered(this._video);
        this._logger.log("current position buffered=".concat(isCurrentPositionBuffered));
        if (!isCurrentPositionBuffered) {
            this._logger.warn('current position is not buffered, check close range');
            this._logger.warn("next buffered start=".concat(videoTool.getNextBufferedStart(this._video)));
            this._logger.warn("last buffered end=".concat(videoTool.getLastBufferedEnd(this._video)));
        }
        // 开始执行重试
        this.retryWhenError(error);
    };
    BaseVideoNode.prototype.retryWhenError = function (error) {
        // 需要先存一下，避免stopInner()把this._videoInfo置空
        var nextVideoInfo = this._videoInfo;
        var retryUrlRet = this.setRetryUrl(nextVideoInfo);
        // 根据url上的过期时间戳判断urlconfig是否可用
        var expireTimeStamp = nextVideoInfo.config.expireTimeStamp;
        var isUrlExpired = typeof expireTimeStamp === 'undefined' ? false : (expireTimeStamp < +new Date());
        if (this._videoInfo.stateWhenErrorHappen === null) {
            // 连续重试只记录一次，因此要判断下null
            this._videoInfo.stateWhenErrorHappen = this._state;
        }
        // 不是最终错误 && urlconfig没有过期 && 有下一个重新地址，这几个条件满足时重试
        if (!error.fatal && !isUrlExpired && retryUrlRet) {
            var retryCount = nextVideoInfo.getRetryCount();
            this._logger.log('retryOnError(), retryCount=', retryCount);
            this.emit(VIDEO_NODE_EVENT.RETRY, __assign({ error: error, retryCount: retryCount, videoInfo: nextVideoInfo }, retryUrlRet));
            this.stopInner(true);
            // 重试的话强行进入buffering状态
            this.stateMgr.setWaiting();
            // 上一句扭转的buffering状态可能不成功（例如是seeking状态卡死导致的重试），所以在出错重试时强制显示loading动画
            if (this._state !== VIDEO_STATE.BUFFERING) {
                this.loading.show();
            }
            this.doRetry(nextVideoInfo);
            return;
        }
        this._logger.log('retryOnError(), fatal.');
        // 无法执行重试，最终失败
        this._videoInfo.error = error;
        // 如果正在切换清晰度，reject promise，抛出异常
        if (this._levelSwitchingDefer) {
            this._levelSwitchingDefer.reject(error);
        }
        this.stopInner(false, this._videoInfo);
    };
    /**
     * 从各种内核的原始信息中解析出的标准的错误信息，basenode只处理未知和标准video错误转换，其他内核需要自行复写
     * @param errorData 原始错误数据
     * @returns 处理过的错误信息
     */
    BaseVideoNode.prototype.parseErrorData = function (errorData) {
        var _a;
        // 注意这里return IVideoError是为了兼容还没有实现ErrorBase的内核
        if (errorData) {
            // 这里将errorData全部标准化为ErrorBase的格式，方便后续处理
            return videoTool.commonErrorParse(errorData);
        }
        // 如果没有任何错误信息，尝试从video标签上获取，如果还是没有则视为未知错误
        return (_a = videoTool.getVideoError(this._video)) !== null && _a !== void 0 ? _a : PlayerError.NativeError({
            code: 0 /* UNKNOWN_ERR */,
            fatal: false,
            message: t(i18nConfig.core.ERROR_MSG_UNKNOWN),
            debugMessage: jsonTool.safelyStringify(this._video.error),
        });
    };
    /** 开始执行重试 */
    BaseVideoNode.prototype.doRetry = function (videoInfo) {
        // 重试的时间获取：
        // 如果video组建时间大于0先拿video组件上的时间，再拿videoInfo的playtime兜底。这是因为seek操作时候如果出现错误重试，videoInfo上的
        // playtime并没有更新，但是video.currentTime已经被设置过来了，video.currentTime就是重试后真实起播点
        var playtime = videoInfo.playtime, stateWhenErrorHappen = videoInfo.stateWhenErrorHappen;
        var retryPlaytime = this._video.currentTime > 0 ? this._video.currentTime : playtime;
        var startTime = this._played ? retryPlaytime : this._userStartTime;
        this._logger.log("do retry [url], stateWhenErrorHappen=".concat(stateWhenErrorHappen));
        // 注意，这个地方要把重试的时间复制回videoInfo上，避免连续失败无法获取时间的问题
        videoInfo.playtime = startTime;
        if (!this._played || stateWhenErrorHappen === VIDEO_STATE.PAUSE) {
            this.load(videoInfo, { startTime: startTime });
        }
        else {
            this.play(videoInfo, { startTime: startTime });
        }
    };
    /**
     * 给IVideoInfo设置准备重试的地址
     * @param vinfo IVideoInfo对象
     * @returns 返回设置重试地址的结果，其中包含设置前和设置后的地址。如果设置失败，返回null值
     */
    BaseVideoNode.prototype.setRetryUrl = function (vinfo) {
        var loadingUrl = vinfo.loadingUrl;
        var prevUrl = loadingUrl;
        var hasNextBackup = vinfo.setNextBackUrl();
        if (hasNextBackup) {
            return { prevUrl: prevUrl, curUrl: vinfo.loadingUrl };
        }
        return null;
    };
    /**
     * 转发内核特殊事件，例如hls内核中，外部可能会监听hls.js事件抛出的一些数据。
     * <br>[注意]需要说明的是，我们使用全局的evtBus来派发内核特殊事件，为了避免多个播放器实例的事件串了，我们会在抛出的数据中携带播放器实例的id
     * @param evt 事件名称
     * @param data 事件数据
     */
    BaseVideoNode.prototype.emitKernelEvt = function (evt, data) {
        kernelEvtBus.emit(evt, __assign(__assign({}, data), { playerInstanceId: this.config.instanceId }));
    };
    BaseVideoNode.prototype.adjustSeekTime = function (time) {
        var targetTime = time;
        if ((uaTool.browser.x5 || uaTool.browser.safari) && Math.abs(targetTime - this._videoInfo.duration) <= 1) {
            // bug：
            // safari / x5下可能出现直接seek到视频的最结尾（seek时间等于视频时长）后，video不发出end事件出来，所以检测如果这种情况，把time值回退1s
            targetTime = this._videoInfo.duration - 1;
        }
        return targetTime;
    };
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "pause", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "stop", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "destroy", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], BaseVideoNode.prototype, "setLevel", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BaseVideoNode.prototype, "setAudioTrack", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "setCheckLoadTimeoutEnable", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "pauseInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "setEndInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Object]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "stopInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "retryWhenError", null);
    return BaseVideoNode;
}(EvtEmitter));
export default BaseVideoNode;
